import { getSumOfSeries } from '../utils';
import './visit-point.scss';

function createPointRow({ name, data }) {
  return `<p class="visit-point text-latin" >${name}: ${data}</p>`;
}

function createBoldPointRow({ name, data, bulletColor }) {
  return (
    '<p class="visit-point visit-point--bold text-latin">' +
    `<span 
      class="visit-point__bullet"
      style="border-left-color: ${bulletColor};border-right-color: ${bulletColor}"
    ></span>` +
    `${name}: ${data}` +
    '</p>'
  );
}
function createChildrenRows(children, index) {
  return children
    .sort((firstChild, secondChild) => {
      const { data } = firstChild;
      const { data: secondData } = secondChild;
      return secondData[index] - data[index];
    })
    .map(({ name, data }) => createPointRow({ name, data: data[index] }));
}
export default function createPointFormatter(primaryChart) {
  const { data: sumData } = getSumOfSeries(primaryChart);
  return function pointFormatter() {
    const {
      userOptions: { name: parentName, data: parentData, children },
      color,
    } = this.series;
    const rows = [
      createBoldPointRow({
        name: 'Total Visit',
        data: sumData[this.index],
        bulletColor: '#000',
      }),
    ];
    if (children) {
      rows.push(
        createBoldPointRow({
          name: parentName,
          data: parentData[this.index],
          bulletColor: color,
        }),
      );
      const childRows = createChildrenRows(children, this.index);
      rows.push(...childRows);
    }
    return rows.join('');
  };
}
